// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./sass/_ResultFolding.scss
// module id = 660
// module chunks = 44 88